<!--to show toaster only if content is loaded-->
@if (!isToaster || (isToaster && page)) {
  <div mat-dialog-title>
    @if (icon) {
      <mat-icon [svgIcon]="icon"></mat-icon>
    }
    <h2>{{ page?.get('label') | loadTemplateData$ | async }}</h2>
    @if (!isToaster) {
      <button
        class="close"
        (click)="closeModal()"
        aria-label="Close dialog">
        <mat-icon svgIcon="cross"></mat-icon>
      </button>
    }
  </div>
  <mat-dialog-content>
    <app-basic-page [page]="page" [title]="false" (action)="closeModal()"></app-basic-page>
  </mat-dialog-content>
  @if (hasActions()) {
    <mat-dialog-actions>
      @if (page?.get('document')) {
        <button (click)="downloadDocument()" mat-raised-button class="mat-accent">
          {{ 'generic.download_document' | translate }}
          @if (downloading) {
            <mat-spinner class="ml-8"></mat-spinner>
          }
        </button>
      }
      @if (labelConfirmDialog?.length > 0) {
        <button  (click)="closeModal()" mat-raised-button class="mat-accent mr-16" >{{labelConfirmDialog}}</button>
      }
      @for (block of blocks; track block) {
        @if (block.type === 'button') {
          <app-button-block [blockData]="block" (action)="closeModal($event)"></app-button-block>
        }
        @if (block.type === 'field') {
          <app-field-block [blockData]="block" (action)="nextOrCloseModal(block)" ></app-field-block>
        }
        @if (hasNext(block)) {
          <app-button-block [blockData]="nextFieldBlock" (action)="nextOrCloseModal(block)" class="right"></app-button-block>
        }
        @if (block.type === 'collections') {
          <app-collections-block [blockData]="block" (action)="closeModal($event)" ></app-collections-block>
        }
      }
    </mat-dialog-actions>
  }
}